export default __webpack_public_path__ + "static/media/IBimageMobilityKnee.ef3ed82c.png";